module.exports = __webpack_public_path__ + "img/academy_logo.a829128e.png";